<template>
    <div class="content_nav">
        <div id="echarts_1">设备管理999</div>
    </div>
</template>